export default function CTA() {
  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostic-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-primary-600 to-primary-700">
      <div className="max-w-5xl mx-auto px-6 text-center text-white">
        <h2 className="text-4xl lg:text-5xl font-bold mb-6">
          Pronto para Transformar seu Negócio?
        </h2>
        <p className="text-xl lg:text-2xl mb-12 opacity-90 max-w-3xl mx-auto">
          Comece agora com um diagnóstico gratuito e descubra como o LBAs Essentials 
          pode levar seu MEI ou pequena empresa para o próximo nível
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button
            onClick={scrollToDiagnostic}
            className="px-10 py-4 bg-coral-500 text-white rounded-lg font-bold text-lg hover:bg-coral-600 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Fazer Diagnóstico Gratuito
          </button>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-10 py-4 bg-transparent border-2 border-white text-white rounded-lg font-bold text-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Agendar Conversa
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-8 pt-12 border-t border-white/20">
          <div>
            <div className="w-16 h-16 bg-coral-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-coral-500"></i>
            </div>
            <h3 className="font-bold text-lg mb-2">Sem Compromisso</h3>
            <p className="text-sm opacity-90">Diagnóstico gratuito sem obrigação de contratação</p>
          </div>
          <div>
            <div className="w-16 h-16 bg-coral-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-3xl text-coral-500"></i>
            </div>
            <h3 className="font-bold text-lg mb-2">Resposta Rápida</h3>
            <p className="text-sm opacity-90">Análise e proposta em até 24 horas</p>
          </div>
          <div>
            <div className="w-16 h-16 bg-coral-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-coral-500"></i>
            </div>
            <h3 className="font-bold text-lg mb-2">Suporte Especializado</h3>
            <p className="text-sm opacity-90">Consultores experientes em MEI e pequenas empresas</p>
          </div>
        </div>
      </div>
    </section>
  );
}
